import { Badge } from '@pryme/ui';
import { pretty } from '../lib/files';
import type { JwsInspection } from '../lib/signing';

/** Decoded compact JWS with its verification outcome. Shows inspection-safe fields only. */
export function JwsCard<P>(props: { title: string; inspection: JwsInspection<P> | null; keyLabel: string; redact?: string[] }) {
  const i = props.inspection;
  if (!i) return null;
  const payload = i.decoded?.payload as Record<string, unknown> | undefined;
  const shown = payload && props.redact ? Object.fromEntries(Object.entries(payload).map(([k, v]) => [k, props.redact!.includes(k) ? '‹redacted›' : v])) : payload;
  return (
    <div className="p-card muted">
      <div className="p-row p-between">
        <h3 style={{ margin: 0 }}>{props.title}</h3>
        {i.verified ? (
          <Badge tone="ok" icon="check">Signature valid · {props.keyLabel} {i.verifiedWith}</Badge>
        ) : (
          <Badge tone="bad" icon="x">Not verified{i.error ? `: ${i.error}` : ''}</Badge>
        )}
      </div>
      {i.decoded && (
        <>
          <p className="dv-code-label" style={{ margin: '0.75rem 0 0.3rem' }}>Protected header</p>
          <pre className="p-code">{pretty(i.decoded.header)}</pre>
          <p className="dv-code-label" style={{ margin: '0.75rem 0 0.3rem' }}>Payload (JCS-canonical JSON, base64url)</p>
          <pre className="p-code">{pretty(shown)}</pre>
        </>
      )}
      <details style={{ marginTop: '0.75rem' }}>
        <summary className="p-small">Compact token</summary>
        <code className="p-mono-chip" style={{ display: 'block' }}>{i.token}</code>
      </details>
    </div>
  );
}
